import List from '@/modules/profile/pages/favorites/components/list/index.vue';
import {mapActions, mapGetters, mapMutations} from "vuex";
import {
    GET_FAVORITES_LIST,
} from "@/store/action-types";
import {
    OPEN_CURRENT_LIST,
    SET_CURRENT_LIST_ID
} from "@/store/mutation-types";

const SingIn = () => import('@/modules/auth/sing-in/index.vue');

export default {
    name: 'favorites-non-auth',
    breadcrumb() {
        return {
            label: this.$t('favorites'),
            parentsList: [
                {
                    path: '/',
                    label: this.$t('main'),
                    name: 'home'
                },
                {
                    path: '/',
                    label: this.$t('profile'),
                    name: 'setting'
                }
            ]
        }
    },
    data(){
        return{
            params: {
                title: '',
                description: '',
                keywords: '',
                image: ''
            },
        }
    },
    head: {
        meta: function () {
            let meta = [
                { n: 'description', c: this.params.description, id: 'description' },
                { n: 'keywords', c: this.params.keywords, id: 'keywords' },
                { n: 'og:title', c: this.params.title, id: 'og:title' },
                { n: 'og:description', c: this.params.description, id: 'og:description' },
            ]

            if (Object.keys(this.$route.query).length > 0) {
                meta.push({ n: 'robots', c: 'noindex, nofollow' })
                return meta
            } else {
                return meta
            }
        },
        link: function () {
            let route = this.$route.path
            return [
                { rel: 'canonical', href: window.location.origin + this.$route.path, id: 'canonical' },
            ]
        }
    },
    components: {
        List,
        SingIn
    },
    computed: {
        ...mapGetters({
            listId: 'favorites/listId',
            loading: 'favorites/loading',
            list: 'favorites/list',
            whichList: 'favorites/whichList',
        }),
        transformWhichList(){
            let result = [];
            this.whichList.forEach(e => {
                result.push(e.id)
            });
            return result;
        }
    },
    created(){
        this.fetchFavorites({ list: this.transformWhichList }).finally(() => {
            if(this.whichList.length > 0){
                if (this.listId) {
                    setTimeout(() => { this.openCurrentList(this.listId); }, 50)
                }else{
                    setTimeout(() => { this.openCurrentList(this.whichList[0].id); }, 50)
                }
            }
        });
    },
    methods: {
        ...mapActions({
            fetchFavorites: `favorites/${GET_FAVORITES_LIST}`
        }),
        ...mapMutations({
            openCurrentList: `favorites/${OPEN_CURRENT_LIST}`,
            setCurrentIdList: `favorites/${SET_CURRENT_LIST_ID}`,
        }),
    },
    destroyed(){
        this.setCurrentIdList(null);
    }
}
